import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Centered single-column page for sign-in, sign-up and invitations. */
export function PublicLayout({
  title,
  intro,
  children,
}: {
  title: string;
  intro?: string;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen bg-bg px-5 py-10 text-fg">
      <div className="mx-auto flex max-w-sm flex-col gap-6">
        <p className="text-center text-xl font-semibold text-accent">{t('app.name')}</p>
        <div>
          <h1 className="text-[26px] font-semibold">{title}</h1>
          {intro && <p className="mt-2 text-muted">{intro}</p>}
        </div>
        {children}
      </div>
    </main>
  );
}
